import { Property, Logo } from '@propertypal/shared/src/types/property';
import React from 'react';
import PropertyAgentBar from '../property/PropertyAgentBar';
import {
  CallAgentModalContainer,
  CallAgentModalImage,
  CallAgentModalOption,
  ContactNumber,
  ContactText,
  CallAgentContactDetails,
  AgentHeader,
} from './CallAgentModal.style';
import WhiteModal from './WhiteModal';

export interface ContactType {
  logo?: Logo;
  logos?: Logo;
  organisation: string;
  developer?: boolean;
  officePhone?: {
    displayNumber: string;
  };
  phoneNumber?: {
    displayNumber: string;
  };
}

interface CallAgentModalProps {
  onClose: () => void;
  show: boolean;
  contacts: ContactType[];
  onSelected?: (organisation: string) => void;
  property?: Property;
}

const CallAgentModal: React.FC<CallAgentModalProps> = ({ onClose, show, contacts, onSelected, property }) => {
  const items = contacts.filter((c) => c.phoneNumber?.displayNumber || c.officePhone?.displayNumber);

  return (
    <WhiteModal
      ariaLabel="Call an agent"
      title="Call"
      show={show}
      onClose={onClose}
      maxWidth={670}
      testID="call-agent-modal"
    >
      {property && (
        <AgentHeader>
          <PropertyAgentBar property={property} onClose={onClose} />
        </AgentHeader>
      )}

      <CallAgentModalContainer>
        {items &&
          items.map((item) => {
            const logo = item.logos || item.logo;
            const phoneNumber = item.phoneNumber?.displayNumber || item.officePhone?.displayNumber || '';

            return (
              <CallAgentModalOption key={item.organisation} data-testid="agent-contact-item">
                {logo && !property?.enhancedBranding && (
                  <CallAgentModalImage src={logo.standard} alt={item.organisation} data-testid="agent-contact-logo" />
                )}
                <CallAgentContactDetails>
                  <ContactText data-testid="agent-contact-text">{item.organisation}</ContactText>
                  <ContactNumber
                    data-testid="agent-contact-number"
                    href={`tel:${phoneNumber.replace(/\s/g, '')}`}
                    onClick={() => onSelected && onSelected(item.organisation)}
                  >
                    {phoneNumber}
                  </ContactNumber>
                </CallAgentContactDetails>
              </CallAgentModalOption>
            );
          })}
      </CallAgentModalContainer>
    </WhiteModal>
  );
};

export default CallAgentModal;
